import React from "react";

export default function CustomAccordian({
  onCardClick,
  activeClass,
  headerText,
  children,
}) {
  return (
    <div className="accordion accordionListWrap">
      <div className={"customAccordionRow card"}>
        <div
          onClick={() => onCardClick()}
          className={`card-header ${activeClass}`}
        >
          <button type="button" className="btn btn-link">
            {headerText}
          </button>
        </div>
        <div className={`collapse ${activeClass}`}>
          <div className="card-body">
            <div className="inner-feed-container">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

CustomAccordian.defaultProps = {
  headerText: "",
  children: null,
  activeClass: "show",
  onCardClick: () => {},
};
